<template>
  <div>
    <div class="es-op-box">
      <el-input
        placeholder="请输故障等级"
        v-model="queryObj.keyWord"
        size="small"
        class="query"
        style="float: left"
        clearable
        @change="
          () => {
            this.queryObj.pageNum = 1;
            init();
          }
        "
      >
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button
        type="primary"
        icon="el-icon-font el-icon-web__tianjia"
        size="mini"
        style="margin-right: 6px"
        @click="add_init"
        >新增</el-button
      >

      <es-delete @del="del()" type="button"></es-delete>
    </div>
    <el-table
      :data="pageData.list"
      ref="levelTable"
      border
      stripe
      size="mini"
      height="calc(100vh - 180px)"
      style="cursor: pointer"
      v-loading="loading"
    >
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="name" label="故障等级"> </el-table-column>
      <el-table-column prop="responseTime" label="规定时长(小时)">
      </el-table-column>
      <el-table-column prop="colorCode" label="等级颜色">
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            title="编辑"
            @click="edit_init(scope.row)"
            type="primary"
            ><i class="el-icon-font el-icon-bianji"></i
          ></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete
            @del="del(scope.row.id)"
            :key="scope.row.id"
            type="icon"
          ></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination
        :data="pageData"
        @change="
          (cpage) => {
            this.queryObj.pageNum = cpage;
            this.loadLevelList();
          }
        "
      >
      </es-pagination>
    </div>

    <!--编辑故障等级-->
    <el-dialog
      :visible.sync="editVisible"
      @closed="() => this.$refs['levelForm'].clearValidate()"
      width="500px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑故障等级
      </span>
      <el-form
        :model="levelInfo"
        :rules="rules"
        size="mini"
        label-position="right"
        label-width="150px"
        ref="levelForm"
      >
        <el-form-item prop="name" label="故障等级">
          <el-input
            v-model="levelInfo.name"
            placeholder="请输入故障等级"
            style="width: 200px"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="responseTime" label="规定时长(小时)">
          <el-input-number
            v-model="levelInfo.responseTime"
            @change="handleChange"
            :min="1"
            label="规定时长"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="colorCode" label="等级颜色">
          <el-input
            v-model="levelInfo.colorCode"
            placeholder="请输入等级颜色"
            style="width: 200px"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="submitLevel()"
          :loading="saving"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "faultlevel",
  props: ["funcs"],
  data() {
    return {
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      levelInfo: {}, //故障等级信息
      rules: {
        //验证条件
        name: [
          { required: true, message: "请输入故障等级", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
        responseTime: [
          { required: true, message: "请输入响应时长", trigger: "blur" },
        ]
      },
      loading: false,
      saving: false,
    };
  },
  methods: {
    //页面初始化
    init() {
      this.loadLevelList();
    },
    //从后台查询故障等级
    loadLevelList() {
      this.loading = true;
      this.$ajax
        .get("/base/faultlevel/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加故障等级
    add_init() {
      this.editVisible = true;
      this.levelInfo = {};
      this.$set(this.levelInfo,"responseTime",4)
      this.$set(this.levelInfo,"colorCode","#606266")
    },
    //初始化编辑故障等级
    edit_init(row) {
      this.editVisible = true;
      this.levelInfo = JSON.parse(JSON.stringify(row));
    },
    //保存故障等级
    submitLevel() {
      console.log(this.levelInfo);
      this.$refs["levelForm"].validate((valid) => {
        if (valid) {
          let url = "/base/faultlevel/add";
          if (this.levelInfo.id != null) {
            url = "/base/faultlevel/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.levelInfo)
            .then((msg) => {
              this.saving = false;
              this.loadLevelList();
              this.editVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除故障等级
    del(delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["levelTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/base/faultlevel/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadLevelList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    handleChange(value) {
      console.log(value);
    },
    stateFormat(row) {
      console.log(row);
      if (row.state == 1) {
        row.statename = "是";
        return "success";
      } else {
        row.statename = "否";
        return "danger";
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
</style>
